import $ from 'jquery';
import Swiper from 'swiper';
import 'jquery-mask-plugin';
import ymaps from 'ymaps';
import { Fancybox } from "@fancyapps/ui";
import Cookies from 'js-cookie';

window.$ = $;
window.jQuery = $;
const isNewV4 = $('.design-v4').hasClass('design-v4');

$(() => {
	Fancybox.bind();
});

// input tel mask //
$('input[name="phone"]').mask('+7 (000) 000-00-00');

// navigation //
$(() => {
	// mobile menu //
	$('.burger-menu').on('click', function () {
		$('.burger-menu').toggleClass('burger-menu--active')
		$('.mobile-menu').toggleClass('mobile-menu--active')
		$('body').toggleClass('body-hidden')
	});

	// nav menu //
	$('.nav__start').on('click', function () {
		$('.nav__burger').toggleClass('nav__burger--active')
		$('.nav__list').toggleClass('nav__list--active')
	});
	$(document).mouseup(function (e) {
		let container = $(".nav");
		if (container.has(e.target).length === 0) {
			$('.nav__burger').removeClass('nav__burger--active')
			$('.nav__list').removeClass('nav__list--active')
		}
	});

	// dropdown menu //
	if (window.matchMedia('(max-width: 991px)').matches) {
		$('.nav-item').addClass('disable');
	}
	$('.nav-item__arrow_mobile').on('click', function () {
		$(this).toggleClass('active');
		$(this).parents('.nav-item__container').find('.nav-item__dropdown').toggleClass('open');
	});

	$('.mobile-menu__nav button').on('click', function () {
		const dropdownMenu = $(this).parents('div').next('ul');

		if (dropdownMenu.is(':visible')) {
			dropdownMenu.css('display', 'none');
			$(this).css('transform', 'rotate(0deg)');

		} else {
			dropdownMenu.css('display', 'block');
			$(this).css('transform', 'rotate(180deg)');
		}
	});

	///////////V3///////////////
	// if ($('.header-v3').length) {
	// 	$('.header-v3 .actions__search, .header-v3 .mobile__search button').on('click', function () {
	// 	$('.header-v3 .mobile__search').toggleClass('mobile__search_active');
	// 	$('.header-v3__mobile').toggleClass('open-search');
	// });

	// $('.header-v3__mobile .dropdown__menu button').on('click', function () {
	// 	const dropdownMenu = $(this).parents('div').next('ul');

	// 		if (dropdownMenu.is(':visible')) {
	// 			dropdownMenu.css('display', 'none');
	// 			$(this).css('transform', 'rotate(0deg)');

	// 		} else {
	// 			dropdownMenu.css('display', 'flex');
	// 			$(this).css('transform', 'rotate(180deg)');
	// 		}
	// 	});
	// 	$('.header-v3__mobile .actions__burger').on('click', function () {
	// 		$('.header-v3__mobile .mobile__dropdown').toggleClass('mobile__dropdown_open');
	// 		$(this).toggleClass('actions__burger_open');
	// 	});
	// }

	

	///////////V4///////////////
	if ($('.header-v4').length) {
		$('[data-type="menu-catalog"]').on('click', function() {
			$('.header-v4__full-menu').toggleClass('open');
			
			if ($('.header-v4__full-menu').hasClass('open')) {
				$('body').css('overflow', 'hidden');
				$('.header-v4 .top__burger img')
					.attr('src', 'assets/template/dist/assets/new-design-2025/i-burger-close.svg');
			} else {
				if (!$('.mobile-menu').hasClass('open')) {
					$('body').css('overflow', 'auto');
				}
				$('.header-v4 .top__burger img')
					.attr('src', 'assets/template/dist/assets/new-design-2024/burger.svg');
			}
		});

		if (window.matchMedia('(max-width: 991px)').matches) {
			// level 1
			$('.header-v4__full-menu .full-menu__left div button').on('click', function(e) {
				e.stopPropagation();
				e.preventDefault();

				const categoryID = $(this).parent().data('category');

				if (!categoryID) return;

				$('.header-v4__full-menu .full-menu__left').hide();
				$(`.full-menu__subcategories[data-parent="${categoryID}"]`).addClass('show');
			});

			// level 1 back
			$('.header-v4__full-menu .subcategories__title').on('click', function(e) {
				e.stopPropagation();
				e.preventDefault();

				$('.header-v4__full-menu .full-menu__left').css('display', 'flex');
				$('.full-menu__subcategories').removeClass('show');
			});

			// level 2
			$('.header-v4__full-menu .subcategories__items > div > button').on('click', function(e) {
				e.stopPropagation();
				e.preventDefault();
				if ($(this).parent().hasClass('open')) return;

				$(this).parents('.full-menu__subcategories').find('.subcategories__title').hide();
				$(this).parents('.subcategories__items').css('marginTop', 0).find('> div').hide();
				$(this).parent().css('display', 'flex').addClass('open');
				$(this).parent().find('div').css('display', 'flex');
			});

			// level 2 back
			$(document).on('click', '.subcategories__items > div.open > .subitem', function(e) {
				e.preventDefault();
				e.stopPropagation();

				$(this).parents('.full-menu__subcategories').find('.subcategories__title').css('display', 'flex');
				$(this).parents('.subcategories__items').css('marginTop', '20px').find('> div').css('display', 'flex');
				$(this).parent().css('display', 'none').removeClass('open');
				$(this).parent().find('div').css('display', 'none');

				return;
			});
		} else {
			$('.header-v4__full-menu .full-menu__left div').on('mouseenter', function() {
				const categoryID = $(this).data('category');

				if (!categoryID) return;

				const height = $('.header-v4__full-menu .container').innerHeight();

				$('.header-v4__full-menu .full-menu__left > div').removeClass('active');
				$(this).addClass('active');
				$('.full-menu__subcategories').removeClass('show');
				$(`.full-menu__subcategories[data-parent="${categoryID}"]`).addClass('show').height(height);

				
				// console.log(height);
				// full-menu__subcategories
			});
		}

		
	}

	
});

// top banner
$(() => {
	if (!$('.header-v3__banner').length) return;

	$('.header-v3__banner .top-banner__close').on('click', function () {
		$('.header-v3__banner').hide();
		$('body').addClass('top-banner-hidden');
		Cookies.set('top-banner-viewed', '1', { expires: 60 });
	});
});

// swiper galerey product //
$(() => {
	let thumbs = new Swiper(".mySwiper", {
		slidesPerView: 3,
	});
	new Swiper(".mySwiper2", {
		slidesPerView: 1,
		// pagination: {
		// 	el: '.swiper-pagination',
		// },
		thumbs: {
			swiper: thumbs,
		},
	});
});

// swiper news //
$(() => {
	new Swiper(".info-slider__swiper", {
		pagination: {
			el: '.info-slider__swiper-pagination',
			clickable: true,
		},
		spaceBetween: 30,
		loop: true,
		autoplay: {
			delay: 5000,
		},

	});
});

// brands //
$(() => {
	new Swiper(".brands__slider", {
		navigation: {
			nextEl: ".brands .brands__buttons .swiper-button-next",
			prevEl: ".brands .brands__buttons .swiper-button-prev",
		},
		slidesPerView: 5,
		spaceBetween: 30,
		loop: true,
		autoplay: {
			delay: 5000,
		},
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			1024: {
				slidesPerView: 5,
				spaceBetween: 30,
			}
		}
	});
});

// product //
$(() => {
	// tabs product character
	$(function () {
		// if (window.innerWidth <= 575) {
		// 	$(".tabs__content").css('display', 'none')
		// }
		$("ul.tabs__caption").on("click", "li:not(.active)", function () {
			$(this)
				.addClass("active")
				.siblings()
				.removeClass("active")
				.closest("div.tabs")
				.find("div.tabs__content")
				.removeClass("active")
				.eq($(this).index())
				.addClass("active");
		});

	});

	// slow scroll
	$(document).ready(function () {
		$("a.product-show__characteristic-link").click(function () {
			$("html, body").animate({
				scrollTop: $($(this).attr("href")).offset().top + "px"
			}, {
				duration: 500,
				easing: "swing"
			});
			return false;
		});
	});
});

// works //
$(() => {
	new Swiper(".works__slider", {
		navigation: {
			nextEl: isNewV4 ? ".works__slider .works__buttons .swiper-button-next" : ".works__slider > .swiper-button-next",
			prevEl: isNewV4 ? ".works__slider .works__buttons .swiper-button-prev" : ".works__slider > .swiper-button-prev",
		},
		spaceBetween: 30,
		slidesPerView: isNewV4 ? 4 : 2,
		loop: true,
		allowTouchMove: false,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			991: {
				slidesPerView: isNewV4 ? 4 : 2
			}
		}
	});

	new Swiper(".item__slider", {
		navigation: {
			nextEl: ".item__slider .swiper-button-next",
			prevEl: ".item__slider .swiper-button-prev",
		},
		pagination: {
			el: ".item__slider .swiper-pagination",
		},
		spaceBetween: 10,
		loop: true,
		autoplay: {
			delay: 5000,
		}
	});
});

// maps //
$(() => {
	const map = $('#map');
	const mapMobile = $('.map__mobile');

	if (map.length && window.matchMedia('(min-width: 991px)').matches) {
		const coords = [
			[55.432393, 37.547665],
			[56.118405, 47.306541]
		];

		ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU').then((maps) => {
			const initParams = {
				center: [55.968721, 42.301109],
				zoom: 6.12,
				controls: []
			}

			const myMap = new maps.Map('map', initParams, {
				searchControlProvider: 'yandex#search',
			});

			coords.forEach((place) => {
				const myPlacemark = new maps.Placemark(place, {}, {});
				myMap.geoObjects.add(myPlacemark);
			});

			myMap.behaviors.disable('scrollZoom');
			map.addClass('noZoom');
			myMap.events.add('click', () => {
				if (map.hasClass('noZoom')) {
					map.removeClass('noZoom').addClass('yesZoom');
					myMap.behaviors.enable('scrollZoom');
				} else {
					map.removeClass('yesZoom').addClass('noZoom');
					myMap.behaviors.disable('scrollZoom');
				}
			});

			const isMobile = {
				Android: () => (navigator.userAgent.match(/Android/i)),
				BlackBerry: () => (navigator.userAgent.match(/BlackBerry/i)),
				iOS: () => (navigator.userAgent.match(/iPhone|iPad|iPod/i)),
				Opera: () => (navigator.userAgent.match(/Opera Mini/i)),
				Windows: () => (navigator.userAgent.match(/IEMobile/i)),
				any: () => (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
			};

			if (isMobile.any()) {
				myMap.behaviors.disable('drag');
			}

		}).catch(error => console.log('Failed to load Yandex Maps', error));
	}

	if (mapMobile.length && window.matchMedia('(max-width: 991px)').matches) {
		mapMobile.each(function () {
			const coords = $(this).data('coords').split(',');
			const mapID = $(this).attr('id');

			ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU').then((maps) => {
				const initParams = {
					center: coords,
					zoom: 16,
					controls: []
				}

				const myMap = new maps.Map(mapID, initParams, {
					searchControlProvider: 'yandex#search',
				});

				const myPlacemark = new maps.Placemark(coords, {}, {});
				myMap.geoObjects.add(myPlacemark);

				myMap.behaviors.disable('scrollZoom');
				map.addClass('noZoom');
				myMap.events.add('click', () => {
					if (map.hasClass('noZoom')) {
						map.removeClass('noZoom').addClass('yesZoom');
						myMap.behaviors.enable('scrollZoom');
					} else {
						map.removeClass('yesZoom').addClass('noZoom');
						myMap.behaviors.disable('scrollZoom');
					}
				});

				const isMobile = {
					Android: () => (navigator.userAgent.match(/Android/i)),
					BlackBerry: () => (navigator.userAgent.match(/BlackBerry/i)),
					iOS: () => (navigator.userAgent.match(/iPhone|iPad|iPod/i)),
					Opera: () => (navigator.userAgent.match(/Opera Mini/i)),
					Windows: () => (navigator.userAgent.match(/IEMobile/i)),
					any: () => (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows())
				};

				if (isMobile.any()) {
					myMap.behaviors.disable('drag');
				}

			}).catch(error => console.log('Failed to load Yandex Maps', error));
		});
	}

	// open/close contacts //
	$('.map__filial').on('click', function () {
		$('.map__info-wrapper').removeClass('active');
		$(this).parents('.map__info-container').find('.map__info-wrapper').addClass('active');
	});
});

// catalog //
$(() => {
	// show/hide filter //
	$('.catalog-filter__show').on('click', function () {
		const target = $(this).data('target');
		$(`[data-content="${target}"]`).toggleClass('active');
		$(this).toggleClass('active');
	});

	// filter mobile //
	$(() => {
		$('.catalog-filter-start__arrow, .catalog-filter__btn').on('click', function () {
			$('.catalog-filter-start__arrow').toggleClass('catalog-filter-start__arrow--active');
			$('.catalog-filter-start__icon').toggleClass('catalog-filter-start__icon--active');
			$('.catalog-filter__mobile').toggleClass('catalog-filter__mobile--active');
			// $('body').toggleClass('body-hidden');
		});

		$('.catalog-filter-content__choice-clear').on('click', () => {
			window.location.href = window.location.origin + window.location.pathname;
		});

		// if (window.matchMedia('(max-width: 991px)').matches) {
		// 	const $filter = $('#mse2_filters').clone(true);
		// 	$('#mse2_filters').remove();
		// 	$('.catalog-filter__mobile').append($filter);
		// }
	});

	// sort mobile
	if (window.matchMedia('(max-width: 991px)').matches) {
		$('.dropdown__selected').on('click', function () {
			$(this).parents('.dropdown').toggleClass('show');
		});
		$('.catalog-sort__select').on('click', function () {
			const text = $(this).text().trim();
			$('#mse2_sort .dropdown__selected span').text(text);
		});
		const initText = $('.catalog-sort__select.active').text().trim();
		if (initText.length) {
			$('#mse2_sort .dropdown__selected span').text(initText);
		}
	}

});

// modals //
$(() => {
	// one click //
	$('[data-type="one-click"]').on('click', function () {
		const data = JSON.parse($('#modalData').text());
		$('.one-click .product-card__name').text(data.title);
		$('.one-click .product-card__desc').text(data.desc);
		$('.one-click .product-card__price_actual').text(`${data.price} ₽`);
		$('.one-click .product-card__price_old').text(data.oldPrice !== '0' ? `${data.oldPrice} ₽` : '');
		$('.one-click .product-card__code').text(`Код ${data.code}`);
		if (data.image !== '' && data.image !== null && data.image !== undefined) {
			$('.one-click .product-card__img').attr('src', data.image).attr('alt', data.title);
		} else {
			$('.one-click .product-card__img').attr('alt', data.title);
		}
		if (data.oldPrice === '0') {
			$('.one-click .product-card__price_old').hide();
		}

		$('.one-click input[name="id"]').val(data.id);

		$('.overlay').fadeIn(300);
		$('.modal.one-click').fadeIn(400);
	});

	$(document).on('af_complete', function (event, response) {
		const { form, success, data } = response;
		if (!success && $(form).hasClass('one-click__form') && data.phone !== undefined) {
			AjaxForm.Message.error(data.phone, 1);
		} else if (!success && $(form).hasClass('fast-callback__form') && data.phone !== undefined) {
			AjaxForm.Message.error(data.phone, 1);
		}

		if (success && $(form).hasClass('one-click__form')) {
			ym(95166898, 'reachGoal', 'SUBMIT_ONE_CLICK_FORM')
		} else if (success && $(form).hasClass('fast-callback__form')) {
			ym(95166898, 'reachGoal', 'SUBMIT_FAST_FORM')
		}
	});

	// fast callback //
	// $('.header__btn, .mobile-menu__btn').on('click', function() {
	// 	$('.overlay').fadeIn(300);
	// 	$('.modal.fast-callback').fadeIn(400);
	// });
	$('[data-type="callback"],[href="#callback"]').on('click', function (e) {
		e.preventDefault();
		$('.overlay').fadeIn(300);
		$('.modal.fast-callback').fadeIn(400);
	});

	// opt callback //
	$('[data-type="opt-callback"]').on('click', function () {
		$('.overlay').fadeIn(300);
		$('.modal.opt-callback').fadeIn(400);
	});

	// review form //
	$('[data-type="review-form"]').on('click', function () {
		$('.overlay').fadeIn(300);
		$('.modal.review-form').fadeIn(400);
	});
	$('[data-type="mobile-menu"]').on('click', function () {
		$('.header-v4__mobile-menu').toggleClass('open');

		if ($('.header-v4__mobile-menu').hasClass('open')) {
			$('body').css('overflow', 'hidden');
		} else {
			$('body').css('overflow', 'auto');
		}
	});

	// cities
	$('[data-type="cities"]').on('click', function () {
		$('.overlay').fadeIn(300);
		$('.modal.cities').fadeIn(400);
	});

	// close
	$('.modal__close').on('click', function () {
		$('.overlay').fadeOut(400);
		$('.modal').fadeOut(300);
	});

	// form input file //
	$('input[type="file"]').on('change', function (e) {
		const path = $(this).val().split('\\');
		$(this).parents('.form__item').find('.form__label_file span').text(path[path.length - 1]).attr('title', path[path.length - 1]);
	});

	// mobile menu
	$('.header__burger').on('click', function () {
		$('.mobile-menu').toggleClass('active');

		if ($('.mobile-menu').hasClass('active')) {
			$(this).find('img').attr('src', 'assets/template/dist/assets/icon/i-cross-blue.svg');
		} else {
			$(this).find('img').attr('src', 'assets/template/dist/assets/icon/i-burger.svg');
		}
	});

	// timer callback //
	const showedTimerCallback = Cookies.get('showed-timer-callback');

	if (showedTimerCallback === undefined || showedTimerCallback != 1) {
		const params = JSON.parse($('#timer-callback-params').text());
		params.delay = +params.delay;
		params.reset = +params.reset;

		setTimeout(() => {
			if ($('.overlay').is(':visible')) return;

			$('.overlay').fadeIn(300);
			$('.modal.timer-callback').fadeIn(400);
			Cookies.set('showed-timer-callback', '1', { expires: params.reset });
		}, params.delay * 1000);
	}

	$('[data-type="timer-callback"]').on('click', function () {
		$('.overlay').fadeIn(300);
		$('.modal.timer-callback').fadeIn(400);
	});
});

// hits main
$(() => {
	const optionsSwiper = {
		// navigation: {
		// 	nextEl: ".similar__nav .swiper-button-next",
		// 	prevEl: ".similar__nav .swiper-button-prev",
		// },
		// pagination: {
		// 	el: ".similar .swiper-pagination",
		// 	clickable: true
		// },
		spaceBetween: 20,
		slidesPerView: 6,
		loop: false,
		breakpoints: {
			320: {
				slidesPerView: 2.1,
				spaceBetween: 10,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 10,
			},
			991: {
				slidesPerView: 6,
				spaceBetween: 20,
			}
		}
	};

	if (isNewV4) {
		new Swiper($(".hits__tab.active .hits__slider")[0], optionsSwiper);
	}
	

	$('.hits__nav button').on('click', function () {
		$('.hits__nav button').removeClass('active');
		$(this).addClass('active');

		$('.hits__tab').removeClass('active');
		$(`#${$(this).data('target')}`).addClass('active');

		if (!isNewV4) return;

		const newSlider = $(`#${$(this).data('target')}`).find('.hits__slider');
		new Swiper(newSlider[0], optionsSwiper);
	});
});

// reviews
$(() => {
	new Swiper(".reviews__slider", {
		navigation: {
			nextEl: ".reviews__slider > .swiper-button-next",
			prevEl: ".reviews__slider > .swiper-button-prev",
		},
		pagination: {
			el: ".reviews .swiper-pagination",
			clickable: true
		},
		spaceBetween: 30,
		slidesPerView: 3,
		loop: true,
		breakpoints: {
			320: {
				slidesPerView: 1
			},
			991: {
				slidesPerView: 3
			}
		}
	});
});

// faq
$(() => {
	$('.faq__quest').on('click', function () {
		// $('.faq__item').removeClass('active');
		$(this).parents('.faq__item').toggleClass('active');
	});
});

// anchors
$(() => {
	$('[data-scroll-to]').on('click', function () {
		const id = $(this).data('scroll-to');
		const $elem = $(`#${id}`);
		if ($elem.length) {
			$([document.documentElement, document.body]).animate({
				scrollTop: $elem.offset().top
			}, 2000);
		}
	});
});

// show/hide filter
$(() => {
	$('.catalog-filter__filters .catalog-filter__title').on('click', function () {
		$(this).parents('.catalog-filter__item').toggleClass('hide');
	});

	$('.catalog-filter__more').on('click', function () {
		$(this).toggleClass('active');
		$(this).parents('fieldset.catalog-filter__item').find('.catalog-filter__rows').toggleClass('scroll');

		if ($(this).hasClass('active')) {
			$(this).find('span').text('Скрыть');
		} else {
			$(this).find('span').text('Показать ещё');
		}
	});

	$('.catalog-filter__filters .catalog-filter__rows').each(function () {
		const height = $(this).innerHeight();

		if (height < 70) {
			$(this).parents('fieldset.catalog-filter__item').find('.catalog-filter__more').hide();
		}
	});
});

// rating input
$(() => {
	$('.form__rating .stars svg').on('mouseover', function () {
		const rating = $(this).data('rating');
		const $container = $(this).parents('.stars');

		if ($container.hasClass('selected')) return;

		$container.find('svg').removeClass('active');

		$container.find('svg').each((index, elem) => {
			const elemRating = +$(elem).data('rating');

			if (elemRating <= rating) {
				$(elem).addClass('active');
			}
		});
	});

	$('.form__rating .stars svg').on('click', function (e) {
		const rating = +$(this).data('rating');
		const $container = $(this).parents('.stars');
		const $input = $(this).parents('.form__item').find('input[name="rating"]');
		const $label = $(this).parents('.form__rating').find('.label')

		$input.val(rating);

		$container.addClass('selected');
		$container.find('svg').removeClass('active');
		$container.find('svg').each((index, elem) => {
			const elemRating = +$(elem).data('rating');

			if (elemRating <= rating) {
				$(elem).addClass('active');
			}
		});

		switch (rating) {
			case 4: {
				$label.text('- хорошо');
				break;
			}
			case 5: {
				$label.text('- отлично');
				break;
			}
			default:
				$label.text('');
				break;
		}

		console.log($input.val());
	});
});

// related
$(() => {
	new Swiper(".related__slider", {
		navigation: {
			nextEl: ".related__nav .swiper-button-next",
			prevEl: ".related__nav .swiper-button-prev",
		},
		pagination: {
			el: ".related .swiper-pagination",
			clickable: true
		},
		spaceBetween: 30,
		slidesPerView: 4,
		loop: false,
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 6,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			991: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		}
	});
});

// similar
$(() => {
	new Swiper(".similar__slider", {
		navigation: {
			nextEl: ".similar__nav .swiper-button-next",
			prevEl: ".similar__nav .swiper-button-prev",
		},
		pagination: {
			el: ".similar .swiper-pagination",
			clickable: true
		},
		spaceBetween: 30,
		slidesPerView: 4,
		loop: false,
		breakpoints: {
			320: {
				slidesPerView: 2,
				spaceBetween: 6,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			991: {
				slidesPerView: 4,
				spaceBetween: 30,
			}
		}
	});
});

// tags product
$(() => {
	$('.product-tags__more').on('click', function () {
		$('.product-tags__item').removeClass('hide');
		$(this).hide();
	});
});

// review product
$(() => {
	$('.reviews__load').on('click', function () {
		$('.reviews__item').removeClass('hide');
		$(this).hide();
	});
});

// auth
$(() => {
	const backToStart = () => {
		$('.auth__step').hide();
		$('.auth__step.auth__step_1').css('display', 'flex');
	};
	const showSignInForm = () => {
		$('.auth__step').hide();
		$('.auth__step.auth__step_2').css('display', 'flex');
	};
	const showConfirmForm = () => {
		$('.auth__step').hide();
		$('.auth__step.auth__step_3').css('display', 'flex');
	};

	// log in
	$('.auth__step_1 .form').on('submit', function (e) {
		e.preventDefault();

		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		const email = $('.auth__step_1 input[name="email"]').val();

		if (!email.length) {
			miniShop2.Message.error('Введите вашу почту');
			return;
		}
		if (!emailRegex.test(email)) {
			miniShop2.Message.error('Введите корректный email');
			return;
		}

		$.post(
			'/assets/components/cabinet/action.php',
			{
				login: email,
				mode: 'log_in'
			},
			function (response) {
				if (!response.error) {
					if (response.action === 'sign_up') {
						showSignInForm();
					} else if (response.action === 'confirm_code') {
						$('.auth__form .form__info b').html(email);
						showConfirmForm();
					}
				} else {
					miniShop2.Message.error(response.message);
				}
			}
		);

		return;
	});

	// sign up
	$('.auth__step_2 .form').on('submit', function (e) {
		e.preventDefault();

		const email = $('.auth__step_1 input[name="email"]').val();
		const name = $('.auth__step_2 input[name="name"]').val();

		if (!name.length) {
			miniShop2.Message.error('Введите ваше имя');
			return;
		}

		$.post(
			'/assets/components/cabinet/action.php',
			{
				email,
				name,
				mode: 'sign_up'
			},
			function (response) {
				if (!response.error) {
					if (response.action === 'confirm_code') {
						$('.auth__form .form__info b').html(email);
						showConfirmForm();
					}
				} else {
					miniShop2.Message.error(response.message);
				}
			}
		);

		return;
	});

	// confirm
	$('.auth__step_3 .form').on('submit', function (e) {
		e.preventDefault();

		const email = $('.auth__step_1 input[name="email"]').val();
		const code = $('.auth__step_3 .form input[name="code"]').val();

		if (!code.length) {
			miniShop2.Message.error('Некорректный код');
			return;
		}

		$.post(
			'/assets/components/cabinet/action.php',
			{
				code,
				email,
				mode: 'confirm'
			},
			function (response) {
				if (!response.error) {
					window.location.pathname = '/profile/';
				} else {
					miniShop2.Message.error(response.message);
				}
			}
		);

		return;
	});

	// back
	$('.auth__form .form__info button').on('click', function () {
		backToStart();
	});
});

// profile
$(() => {
	// edit
	$('.profile__form').on('submit', function (e) {
		e.preventDefault();

		const fields = $(this).serializeArray();
		const postData = {
			mode: 'edit'
		};

		fields.forEach((item) => {
			postData[item.name] = item.value;
		});

		$('.accound__name').text(`${postData.fullname} ${postData.lastname}`);

		$.post(
			'/assets/components/cabinet/action.php',
			postData,
			function (response) {
				if (!response.error) {
					miniShop2.Message.success('Данные профиля обновлены');
					accessForm(true);
				} else {
					miniShop2.Message.error(response.message);
				}
			}
		);

		return;
	});

	// history
	$('.order__preview').on('click', function () {
		$(this).parents('.profile__order').toggleClass('profile__order_open');
	});
});

// add/change cart
$(() => {
	// in catalog page
	const isCartPage = !!$('#msCart').length;
	const isProductPage = !!$('#msProduct').length;

	const numWord = (value, words, show = true) => {
		let num = value % 100;
		if (num > 19) {
			num = num % 10;
		}
	
		let out = show ? value + ' ' : '';
	
		switch (num) {
			case 1:
				out += words[0];
				break;
			case 2:
			case 3:
			case 4:
				out += words[1];
				break;
			default:
				out += words[2];
		}
	
		return out;
	}
	const onChangeCount = (data) => {
		$('.ms2_total_count').text(data.total_count);

		if (!isCartPage) return;

		if (data.total_count === 0) {
			location.reload();
			return;
		}

		const { cart } = data;
		let totalCost = 0;
		let totalOldCost = 0;

		for (const key in cart) {
			const item = cart[key];
			const count = +item.count;
			const price = +item.price;
			const oldPrice = +item.old_price;
			const cost = Math.ceil(price) * count;
			const oldCost = oldPrice ? (Math.ceil(oldPrice) * count) : cost;

			totalCost += cost;
			totalOldCost += oldCost;
		}

		const totalSale =  Math.ceil(totalOldCost - totalCost) * -1;
		const numberWord = numWord(data.total_count, ['товар', 'товара', 'товаров'], false);

		$('.ms2_total_cost').text(miniShop2.Utils.formatPrice(totalCost));
		$('.ms2_total_old_cost').text(miniShop2.Utils.formatPrice(totalOldCost));
		$('.ms2_total_sale').text(miniShop2.Utils.formatPrice(totalSale));
		$('.ms2_total_count_word').text(numberWord);
	}
	const addProduct = ($form) => {
		const id = $form.find('input[name="id"]').val();
		const options = $form.find('input[name="options"]').val();
		let count = $form.hasClass('product-show__buy') ? $form.find('input[name="count"]').val() : '1';

		const data = [
			{ name: 'id', value: id },
			{ name: 'count', value: count },
			{ name: 'options', value: options },
			{ name: 'ms2_action', value: 'cart/add' },
			{ name: 'ctx', value: 'web' },
		];

		$.ajax({
			type: "POST",
			data: data,
			url: '/assets/components/minishop2/action.php',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data.success == true) {
					miniShop2.Message.success(data.message);
					
					if ($form.hasClass('product-show__buy')) {
						$form.find('input[name="key"]').val(data.data.key);
						$form.find('input[name="count"]').val(data.data.row.count);
						$form.attr('data-action', 'cart/change');
					} else if (!isCartPage) {
						const $product = $form.parents('.product-card');
						const $formCount = $product.find('.product-card__count');

						$formCount.find('input[name="key"]').val(data.data.key);
						$formCount.find('input[name="count"]').val(data.data.row.count);
						$form.removeClass('show');
						$formCount.addClass('show');
					}
					
					onChangeCount(data.data);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.responseText);
			}
		});
	}
	const changeCountProduct = ($input) => {
		let $form = $input.parents('.product__count');

		if ($input.parents('.product-show__buy').length) {
			$form = $input.parents('.product-show__buy');
		}

		const key = $form.find('input[name="key"]').val();
		const count = $form.find('input[name="count"]').val();
		const data = [
			{ name: 'key', value: key },
			{ name: 'count', value: count },
			{ name: 'ms2_action', value: 'cart/change' },
			{ name: 'ctx', value: 'web' },
		];

		$.ajax({
			type: "POST",
			data: data,
			url: '/assets/components/minishop2/action.php',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data.success == true) {
					miniShop2.Message.success(data.message);	

					if (count == 0) {
						if (isCartPage) {
							$(`.basket__product[data-key="${key}"]`).remove();
						} else if (isProductPage) {

						} else {
							const $product = $form.parents('.product-card');
							const $buyForm = $product.find('.product-card__buy');

							$form.find('input[name="key"]').val('');
							$form.find('input[name="count"]').val('1');
							$form.removeClass('show');
							$buyForm.addClass('show');
						}
					}

					onChangeCount(data.data);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.responseText);
			}
		});
	}
	const removeProduct = ($form) => {
		const key = $form.find('input[name="key"]').val();
		const data = [
			{ name: 'key', value: key },
			{ name: 'ms2_action', value: 'cart/remove' },
			{ name: 'ctx', value: 'web' },
		];

		$.ajax({
			type: "POST",
			data: data,
			url: '/assets/components/minishop2/action.php',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data.success == true) {
					miniShop2.Message.success(data.message);
					
					if (isCartPage) {
						$(`.basket__product[data-key="${key}"]`).remove();
					} else {
						const $product = $form.parents('.product-card');
						const $buyForm = $product.find('.product-card__buy');

						$form.find('input[name="key"]').val('');
						$form.find('input[name="count"]').val('1');
						$form.removeClass('show');
						$buyForm.addClass('show');
					}

					onChangeCount(data.data);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.responseText);
			}
		});
	}
	const addProductV2 = ($form) => {
		const id = $form.find('input[name="id"]').val();
		const options = $form.find('input[name="options"]').val();
		let count = $form.find('input[name="count"]').val();

		const data = [
			{ name: 'id', value: id },
			{ name: 'count', value: count },
			{ name: 'options', value: options },
			{ name: 'ms2_action', value: 'cart/add' },
			{ name: 'ctx', value: 'web' },
		];

		$.ajax({
			type: "POST",
			data: data,
			url: '/assets/components/minishop2/action.php',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data.success == true) {
					miniShop2.Message.success(data.message);
					
					if (!isCartPage) {
						const $product = $form.parents('.product-card-v2');
						const $formCount = $product.find('.product-card-v2__change');

						$formCount.find('input[name="key"]').val(data.data.key);
						$formCount.find('input[name="count"]').val(data.data.row.count);
						$form.removeClass('show');
						$formCount.addClass('show');
					}
					
					onChangeCount(data.data);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.responseText);
			}
		});
	}
	const changeCountProductV2 = ($input) => {
		let $form = $input.parents('.product-card-v2__change');

		const key = $form.find('input[name="key"]').val();
		const count = $form.find('input[name="count"]').val();
		const data = [
			{ name: 'key', value: key },
			{ name: 'count', value: count },
			{ name: 'ms2_action', value: 'cart/change' },
			{ name: 'ctx', value: 'web' },
		];

		$.ajax({
			type: "POST",
			data: data,
			url: '/assets/components/minishop2/action.php',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data.success == true) {
					miniShop2.Message.success(data.message);	

					if (count == 0) {
						const $product = $form.parents('.product-card-v2');
						const $buyForm = $product.find('.product-card-v2__buy');

						$form.find('input[name="key"]').val('');
						$form.find('input[name="count"]').val('1');
						$form.removeClass('show');
						$buyForm.addClass('show');
					}

					onChangeCount(data.data);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.responseText);
			}
		});
	}
	const removeProductV2 = ($form) => {
		const key = $form.find('input[name="key"]').val();
		const data = [
			{ name: 'key', value: key },
			{ name: 'ms2_action', value: 'cart/remove' },
			{ name: 'ctx', value: 'web' },
		];

		$.ajax({
			type: "POST",
			data: data,
			url: '/assets/components/minishop2/action.php',
			dataType: 'json',
			success: function (data) {
				// console.log(data);
				if (data.success == true) {
					miniShop2.Message.success(data.message);
					
					const $product = $form.parents('.product-card-v2');
					const $buyForm = $product.find('.product-card-v2__buy');

					$form.find('input[name="key"]').val('');
					$form.find('input[name="count"]').val('1');
					$form.removeClass('show');
					$buyForm.addClass('show');
					$buyForm.find('input[name="count"]').val('1');

					onChangeCount(data.data);
				}
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.responseText);
			}
		});
	}

	// in product card v1
	$('.product-card__buy').on('submit', function(e) {
		e.preventDefault();

		addProduct($(this));
	});
	$('.product__count input[name="count"]').on('change', function () {
		changeCountProduct($(this));
	});
	$('.product__count > div button').on('click', function() {
		const $form = $(this).parents('.product__count');
		const $input = $form.find('input[name="count"]');
		const action = $(this).data('action');
		const origValue = +$input.val();
		let newValue = origValue;

		if (action === 'remove') {
			newValue -= 1;

			if (newValue <= 0) {
				removeProduct($form);
				return;
			}
		}
		if (action === 'add') {
			newValue += 1;
		}

		$input.val(newValue);

		changeCountProduct($input);
	});

	// in product card v2
	$('.product-card-v2__buy').on('submit', function(e) {
		e.preventDefault();

		addProductV2($(this));
	});
	$('.product-card-v2__change input[name="count"]').on('change', function () {
		changeCountProductV2($(this));
	});
	$('.product-card-v2 button[data-action]').on('click', function() {
		const $changeForm = $(this).parents('.product-card-v2__change');
		const isChangeForm = !!$changeForm.length;
		const type = $(this).data('action');
		const $input = $(this).parent().find('input[name="count"]');
		const value = +$input.val();
		let newValue = value;

		switch (type) {
			case 'add': {
				newValue += 1;
				break;
			}
			case 'remove': {
				newValue -= 1;

				if (newValue <= 0) {
					if (isChangeForm) {
						removeProductV2($changeForm);
						newValue = value;
						$input.val(newValue);
						return;
					}
					newValue = value;
				}
				break;
			}
			default:
				break;
		}

		$input.val(newValue);
		$input.trigger('change');
	});
	$('.product-card-v2__change').on('submit', function(e) {
		e.preventDefault();

		removeProductV2($(this));
	});
	// $('.product__count > div button').on('click', function() {
	// 	const $form = $(this).parents('.product__count');
	// 	const $input = $form.find('input[name="count"]');
	// 	const action = $(this).data('action');
	// 	const origValue = +$input.val();
	// 	let newValue = origValue;

	// 	if (action === 'remove') {
	// 		newValue -= 1;

	// 		if (newValue <= 0) {
	// 			removeProduct($form);
	// 			return;
	// 		}
	// 	}
	// 	if (action === 'add') {
	// 		newValue += 1;
	// 	}

	// 	$input.val(newValue);

	// 	changeCountProduct($input);
	// });

	// in cart remove
	$('.product__remove').on('submit', function(e) {
		e.preventDefault();

		removeProduct($(this));
	});

	// in product page
	$('.product-show__buy').on('submit', function(e) {
		e.preventDefault();

		const $form = $(this);
		const $countInput = $form.find('input[name="count"]');
		const action = $(document).find('.product-show__buy').attr('data-action');

		if (action === 'cart/add') {
			addProduct($form);
		} else if (action === 'cart/change') {
			changeCountProduct($countInput);
		}
		
	});
	$('.product-show__count button').on('click', function () {
		const type = $(this).data('type');
		const $input = $(this).parents('.product-show__count').find('input[name="count"]');
		const value = +$input.val();
		let newValue = value;

		switch (type) {
			case 'plus': {
				newValue += 1;
				break;
			}
			case 'minus': {
				newValue -= 1;

				if (newValue <= 0) newValue = value;
				break;
			}
			default:
				break;
		}

		$input.val(newValue);
	});
});

// order
$(() => {
	$('.order__form input[name="firstname"], .order__form input[name="lastname"]').on('blur', function() {
		const name = $('.order__form input[name="firstname"]').val();
		const last = $('.order__form input[name="lastname"]').val();

		$('.order__form input[name="receiver"]').val(`${last} ${name}`);
	});
});

// cities
$(() => {
	const $searchInput = $('.modal.cities input[name="search"]');
    const $cityButtons = $('.modal.cities .cities__items button');
	const $cityText = $('.mobile__place span, .contacts__item_place span');
	// const cityFromStorage = localStorage.getItem('city');

	// if (cityFromStorage) {
	// 	$cityText.text(cityFromStorage);
	// }

    $searchInput.on('input', function() {
        const query = $(this).val().trim().toLowerCase();

        if (query === '') {
            // Если пусто — показать все
            $cityButtons.removeClass('hidden');
        } else {
            $cityButtons.each(function() {
                const cityText = $(this).text().toLowerCase();
                if (cityText.includes(query)) {
                    $(this).removeClass('hidden');
                } else {
                    $(this).addClass('hidden');
                }
            });
        }
    });

	$cityButtons.on('click', function() {
		// const city = $(this).text();

		// localStorage.setItem('city', city);
		// $cityText.text(city);

		$('.modal.cities .modal__close').trigger('click');
	});
});

// mobile menu
$(() => {
	$('.header-v4__mobile-menu .mobile-menu__items li button').on('click', function(e) {
		e.stopPropagation();
		const parents = $(this).parents('li');
		$(this).parent().toggleClass('open');
	});
});

// copy email
$(() => {
	const copyTextToClipboard = (text, successText) => {
		// Проверяем поддержку современного API
		if (navigator.clipboard && window.isSecureContext) {
			// Используем асинхронное копирование через Clipboard API
			return navigator.clipboard.writeText(text).then(() => {
				miniShop2.Message.success(successText);
			}).catch(err => {
				console.error('Ошибка при копировании: ', err);
			});
		} else {
			// Резервный метод для старых браузеров
			const textArea = document.createElement("textarea");
			textArea.value = text;
			
			// Скрываем textarea
			textArea.style.position = "fixed";
			textArea.style.left = "-999999px";
			textArea.style.top = "-999999px";
			
			document.body.appendChild(textArea);
			textArea.focus();
			textArea.select();
			
			try {
				const successful = document.execCommand('copy');
				if (!successful) {
					console.error('Не удалось скопировать текст');
				}
			} catch (err) {
				console.error('Ошибка при копировании: ', err);
			}
			
			document.body.removeChild(textArea);
		}
	}

	$('.navigation__email button, .mobile-menu__email button').on('click', function() {
		const copyText = $(this).data('copy');
		copyTextToClipboard(copyText, 'E-mail скопирован');
	});
});

// download all docsuments
$(() => {
	$('.product-show__docs button').on('click', function(e) {
        e.preventDefault();

        const $docLinks = $('.product-show__docs a');
        
        if ($docLinks.length === 0) {
			miniShop2.Message.error('Не найдено документов для скачивания');
            return;
        }
        
        const delay = 500;
        
        $docLinks.each(function(index) {
            const url = $(this).attr('href');
            
            setTimeout(() => {
                const $tempLink = $('<a>')
                    .attr({
                        'href': url,
                        'download': '',
                        'target': '_blank'
                    })
                    .css('display', 'none');
                
                $('body').append($tempLink);
                $tempLink[0].click();
                $tempLink.remove();
            }, index * delay); // Задерживаем каждый следующий запрос
        });
    });
});

// contacts 
$(() => {
	$('.geo .locations__tabs button').on('click', function() {
		const type = $(this).data('type');

		$('.geo .locations__tabs button, .geo .locations__list').removeClass('active');

		$(this).addClass('active');
		$(`.geo .locations__list[data-type="${type}"]`).addClass('active');
	});
});

// map contacts
$(() => {
	// ─── Путь к PNG-иконке маркера (пусто = цифровой маркер по умолчанию) ─
	const MARKER_ICON = 'assets/template/dist/assets/icon/i-pin-contacts.png';

	// ─── Данные точек (координаты: [lng, lat] — долгота, широта) ─
	const POINTS = {
		filials: [],
		pvz: []
	};

	$('.locations__list[data-type="filials"] .item__point').each(function() {
		let point = $(this).data('point');
		if (point.length) {
			point = point.split(',');
			POINTS.filials.push([+point[1], +point[0]]);
		}
	});
	$('.locations__list[data-type="pvz"] .item__point').each(function() {
		let point = $(this).data('point');
		if (point.length) {
			point = point.split(',');
			POINTS.pvz.push([+point[1], +point[0]]);
		}
	});

	// ─── Главная асинхронная функция ──────────────────────────────
	async function initMap() {

		// Ждём загрузки ymaps3 и DOM
		await ymaps3.ready;

		// Деструктурируем нужные классы из ymaps3
		const YMap = ymaps3.YMap;
		const YMapDefaultSchemeLayer = ymaps3.YMapDefaultSchemeLayer;
		const YMapDefaultFeaturesLayer = ymaps3.YMapDefaultFeaturesLayer;
		const YMapMarker = ymaps3.YMapMarker;
		const YMapControls = ymaps3.YMapControls;

		// Подключаем пакет с элементами управления
		const controlsPackage = await ymaps3.import('@yandex/ymaps3-controls@0.0.1');
		const YMapZoomControl = controlsPackage.YMapZoomControl;

		// ── Создание карты ────────────────────────────────────────
		const map = new YMap(
			document.getElementById('contacts-map'),
			{
				location: { center: [37.61, 55.75], zoom: 10 },
				showScaleInCopyrights: true,
			}
		);

		// Базовые слои
		map.addChild(new YMapDefaultSchemeLayer({}));
		map.addChild(new YMapDefaultFeaturesLayer({}));

		// Зум-контрол
		const controls = new YMapControls({ position: 'right' });
		controls.addChild(new YMapZoomControl({}));
		map.addChild(controls);

		// ── Рендер маркеров ─────────────────────────────────────────
		let activeMarkers = [];

		const renderMarkers = (points) => {
			activeMarkers.forEach(m => map.removeChild(m));
			activeMarkers = [];

			points.forEach(point => {
				const markerEl = document.createElement('div');
				markerEl.className = 'custom-marker';
				markerEl.style.cssText = 'width:27px;height:38px;transform:translate(-50%,-50%)';
				markerEl.innerHTML = '<img src="' + MARKER_ICON + '" width="27" height="38" alt="">';

				const marker = new YMapMarker(
					{ coordinates: point },
					markerEl
				);

				map.addChild(marker);
				activeMarkers.push(marker);
			});
		};

		// ── Авто-охват набора точек ───────────────────────────────
		const fitPoints = (points) => {
			if (!points.length) return;

			let minLng = Infinity, minLat = Infinity;
			let maxLng = -Infinity, maxLat = -Infinity;

			points.forEach(p => {
				if (p[0] < minLng) minLng = p[0];
				if (p[1] < minLat) minLat = p[1];
				if (p[0] > maxLng) maxLng = p[0];
				if (p[1] > maxLat) maxLat = p[1];
			});

			const padLng = (maxLng - minLng) * 0.15 || 0.05;
			const padLat = (maxLat - minLat) * 0.15 || 0.05;

			map.update({
				location: {
					bounds: [[minLng - padLng, minLat - padLat], [maxLng + padLng, maxLat + padLat]],
					duration: 500,
				}
			});
		};

		// Начальный рендер — filials по умолчанию
		renderMarkers(POINTS.filials);
		fitPoints(POINTS.filials);

		// ── Клик по элементу списка → центрирование ───────────────
		$('.locations .item__point').on('click', function () {
			let point = $(this).data('point');
			point = point.split(',');

			map.update({
				location: {
					center: [+point[1], +point[0]],
					zoom: 15,
					duration: 600,
				}
			});
		});

		// ── Переключение типа точек ───────────────────────────────
		$('.locations__tabs button').on('click', function() {
			const type = $(this).data('type');
			const points = POINTS[type] || [];

			renderMarkers(points);
			fitPoints(points);
		});
	}

	// ── Запуск ────────────────────────────────────────────────────
	initMap().catch(function (err) {
		console.error('Ошибка инициализации карты:', err);
	});
})